import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getImoveisDestaques, getImoveisLancamentos } from '../services/api';
import ImovelCard from '../components/ImovelCard';
import './Home.css';

const Home = () => {
  const [destaques, setDestaques] = useState([]);
  const [lancamentos, setLancamentos] = useState([]);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [destaquesRes, lancamentosRes] = await Promise.all([
        getImoveisDestaques(),
        getImoveisLancamentos()
      ]);

      setDestaques(destaquesRes.data);
      setLancamentos(lancamentosRes.data);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    window.location.href = `/imoveis?${new URLSearchParams(filters).toString()}`;
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>O que deseja?</h1>
          <div className="search-box">
            <select
              value={filters.cidade || ''}
              onChange={(e) => setFilters({ ...filters, cidade: e.target.value })}
              className="search-select"
            >
              <option value="">Todas as cidades</option>
              <option value="Santa Luzia">Santa Luzia</option>
              <option value="Belo Horizonte">Belo Horizonte</option>
            </select>
            <input
              type="text"
              placeholder="Bairro"
              value={filters.bairro || ''}
              onChange={(e) => setFilters({ ...filters, bairro: e.target.value })}
            />
            <button onClick={handleSearch} className="btn-search">
              Buscar
            </button>
          </div>
          <Link to="/imoveis" className="link-buscar-codigo">
            Buscar por código
          </Link>
        </div>
      </section>

      {/* Oportunidade de Hoje */}
      {destaques.length > 0 && (
        <section className="section">
          <h2 className="section-title">Oportunidade de hoje</h2>
          <div className="imoveis-grid">
            {destaques.slice(0, 8).map(imovel => (
              <ImovelCard key={imovel.id} imovel={imovel} />
            ))}
          </div>
        </section>
      )}

      {/* Lançamentos */}
      {lancamentos.length > 0 && (
        <section className="section">
          <h2 className="section-title">Destaques de lançamento</h2>
          <p className="section-subtitle">Os melhores imóveis para investir</p>
          <div className="imoveis-grid">
            {lancamentos.map(imovel => (
              <ImovelCard key={imovel.id} imovel={imovel} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default Home;

